

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import TeamRepository from "../services/TeamRepository";
import {Team} from "@/models/team.models";
import {ListCustomer} from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import {EmployeeCreate} from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import {ReceiverReportCreate} from "@/models/receiverReportCreate";
import {ReceiverReport} from "@/models/receiverReport";
import {FilterMatchMode} from "primevue/api";

export default {

  setup(){
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const customer = ref({} as ListCustomer);
    const teamId = ref("");
    const listCustomer = ref([] as ListCustomer[]);

    const receiverReportCreate = ref({} as ReceiverReportCreate);
    const listReceiver = ref([] as ReceiverReport[]);

    const valid = computed(()=> register.value.password && register.value.username && register.value.team && register.value.fullname && register.value.address);

const getList = () => {
  ZaloRepository.getListCustomer()
      .then((response) => {
        listCustomer.value = response.data;
        getListReceiver();
      })
      .catch(err => {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail:'Lỗi khi tải danh sách khách hàng',
          life: 2000
        });
      });
}
    getList();

    const getListReceiver = () => {
      ZaloRepository.getListReceiverReport()
          .then((response) => {
            listReceiver.value = response.data;
            listReceiver.value.forEach(x => {
              listCustomer.value.filter(y => {
                if(y.id == x.idZalo) x.imageLink = y.imageUrl;
                console.log("########## image link: " + x.imageLink);
              })
            });
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách thành viên',
              life: 2000
            });
          });
    }

    // getListReceiver();

    const doRegister = () => {
      receiverReportCreate.value.idZalo = customer.value.id;
      receiverReportCreate.value.zaloName = customer.value.name;
        zaloRepository.createReceiverReport(receiverReportCreate.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Đăng ký',
                    detail: 'Đăng ký thành viên thành công vào hệ thống',
                    life: 2000
                  });
                  getListReceiver();
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail:err.response.data,
                    life: 2000
                  });
                });
    }

    const doDelete = (id: number) => {
      zaloRepository.deleteReceiverReport(id)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Xoá',
              detail: 'Xoá thành viên thành công khỏi hệ thống',
              life: 2000
            });
            getListReceiver();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:err.response.data,
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    return {
      register,
      doRegister,
      valid,
      error,
      listCustomer,
      customer,
      teamId,
      listReceiver,
      doDelete,
      filters,
      clearFilter,
      initFilters,
    }
  }
}

